import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

// Actions
import {
  reportsMainGenerateReportProgress
} from 'Redux/actions';

// Helpers
import {
  getTimeZone,
  getCategoryFilter
} from 'Modules/reports/views/main/components/reportsTab/helper';
function* getTimeCardSummaryReport(report, event) {
  const { timeZone , name, reportTimeRanges} = report;
  const { filterType,  page, rowsPerPage, sortField, sortOrder, startRange, endRange } = report.filters;
  const { filterArray }  = event.filters
  try {
    let data = yield call(
      clientQuery,
      `query( $conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getTimeCardSummaryReport(conditions: $conditions, limit: $limit, offset: $offset) {
          summaryInfo {
            dateList
            timeCardTotals {
                date
                duration
            }
          }
        }
      }`,
      {
        conditions: {
          reportName: name,
          category: {
            field: getCategoryFilter(filterType) || filterType,
            value: filterArray
          },
          timeZone: getTimeZone(timeZone),
          dateRange: {
            fields: [
              "unitTime"
            ],
            GTE: startRange,
            LTE: endRange,
            reportTimeRanges
          },
          sortField: {
            field: sortField || "deviceId",
            order: sortOrder === 'desc' ? 'DESC' : 'ASC'
          }
        },
        limit: 10,
        offset: 1
      },
      endpoints.GRAPHQL_PX_REPORTING,
    );
  
    if (data?.Report) {
      report.summary = data.Report
      report.loadingSummary = false
      yield put(reportsMainGenerateReportProgress(report))
    } else {
      report.loadingSummary = false
      yield put(reportsMainGenerateReportProgress(report))
    }
  } catch (exc) {
    report.loadingSubEvents = false
    ExceptionManager(exc, 'src/modules/reports/views/main/components/reportsTab/.components/reports/idleReport', 'getTimeCardSummaryReport');
    yield put(reportsMainGenerateReportProgress(report))
  }
}

export default getTimeCardSummaryReport;